import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from 'react';
import styled from 'styled-components';

export default function FaqItemForm(props) {
    const {
        onDelete = () => {

        }
    } = props;

    const [ruName, setRuName] = useState(props.ruName || '');
    const [enName, setEnName] = useState(props.enName || '');
    const [ruDescription, setRuDescription] = useState(props.ruDescription || '');
    const [enDescription, setEnDescription] = useState(props.enDescription || '');

    return (
        <Wrapper>

            <Row>
                <Label>Вопрос (ru)</Label>
                <Input value={ruName} onChange={e => setRuName(e.target.value)} />
            </Row>

            <Row>
                <Label>Question (en)</Label>
                <Input value={enName} onChange={e => setEnName(e.target.value)} />
            </Row>

            <Row>
                <Label>Ответ (ru)</Label>
                <Textarea value={ruDescription} onChange={e => setRuDescription(e.target.value)} />
            </Row>

            <Row>
                <Label>Answer (en)</Label>
                <Textarea value={enDescription} onChange={e => setEnDescription(e.target.value)} />
            </Row>

            <div>
                <button onClick={() => props.onSave({ ruName, enName, ruDescription, enDescription })}>Сохранить</button>
            </div>

            {props.canDelete != true ? null :
                <div className={'mt-8'} >
                    <button className={'text-red'} onClick={() => props.onDelete()}>удалить</button>
                </div>
            }




        </Wrapper>
    );
}

const Wrapper = styled.div`
    
`;

const Row = styled.div`
  margin-bottom: 10px;
`;

const Label = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const Input = styled.input`
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  padding-left: 4px;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;

const Textarea = styled.textarea`
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  padding-left: 4px;
  width: 100%;
  outline: none;
  border: 1px solid whitesmoke;

  :focus {
    border-color: blue;
  }
`;